import React, { useEffect } from 'react';
import { CardBody, Row, Col } from 'reactstrap';
import { find, lowerCase } from 'lodash';
import { CardTitle, Field } from '@cordata/buffet';
import { useFormikContext } from 'formik';

const yesNoUnknown = [
  'Yes',
  'No',
  'Unknown',
].map(label => ({
  label,
  value: lowerCase(label),
}));

const naloxoneAdministeredByAnswers = [
  'EMS',
  'Law Enforcement',
  'Other individual',
  'Unknown',
].map(label => ({
  label,
  value: lowerCase(label.replace(/ /g, '')),
}));

const acceptedTreatmentAnswers = [
  'Accepted',
  'Refused',
  'Unknown',
].map(label => ({
  label,
  value: lowerCase(label),
}));

const routeOfNaloxoneAdministration = [
  'Nasal',
  'Injection',
  'IV',
].map(label => ({
  label,
  value: lowerCase(label),
}));

const DrugOverdoseForm = () => {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (values.detailObject) {
      setFieldValue('naloxoneAdministered', values.detailObject.naloxoneAdministered && find(yesNoUnknown, r => r.value === values.detailObject.naloxoneAdministered).value);
      setFieldValue('naloxoneAdministeredBy', values.detailObject.naloxoneAdministeredBy && find(naloxoneAdministeredByAnswers, r => r.value === values.detailObject.naloxoneAdministeredBy).value);
      setFieldValue('routeOfNaloxoneAdministration', values.detailObject.routeOfNaloxoneAdministration && find(routeOfNaloxoneAdministration, r => r.value === values.detailObject.routeOfNaloxoneAdministration).value);
      setFieldValue('amountOfNaloxoneGiven', values.detailObject.amountOfNaloxoneGiven);
      setFieldValue('wasOverdoseFatal', values.detailObject.wasOverdoseFatal && find(yesNoUnknown, r => r.value === values.detailObject.wasOverdoseFatal).value);
      setFieldValue('acceptedTreatment', values.detailObject.acceptedTreatment && find(acceptedTreatmentAnswers, r => r.value === values.detailObject.acceptedTreatment).value);
      setFieldValue('wasTransportedToHospital', values.detailObject.wasTransportedToHospital && find(yesNoUnknown, r => r.value === values.detailObject.wasTransportedToHospital).value);
    }
  }, [values.detailObject]);

  return (
    <>
      <hr />

      <CardBody>
        <CardTitle>Drug Overdose Details</CardTitle>

        <Row form>
          <Col sm>
            <Field
              name="naloxoneAdministered"
              label="Was Naloxone administered?"
              type="radio-group"
              options={yesNoUnknown}
              required
              inline
            />
          </Col>

          {values.naloxoneAdministered && values.naloxoneAdministered === 'yes' && (
            <>
              <Col sm>
                <Field
                  name="naloxoneAdministeredBy"
                  label="Naloxone administered by?"
                  type="radio-group"
                  options={naloxoneAdministeredByAnswers}
                  required
                  inline
                />
              </Col>

              <Col sm>
                <Field
                  name="routeOfNaloxoneAdministration"
                  label="Route of Naloxone administration"
                  type="radio-group"
                  options={routeOfNaloxoneAdministration}
                  required
                  inline
                />
              </Col>

              <Col sm>
                <Field
                  name="amountOfNaloxoneGiven"
                  label="Amount of Naloxone given"
                  type="number"
                />
              </Col>
            </>
          )}
        </Row>

        <Row form>
          <Col sm>
            <Field
              name="wasOverdoseFatal"
              label="Was the overdose fatal?"
              type="radio-group"
              options={yesNoUnknown}
              required
              inline
            />
          </Col>

          {values.wasOverdoseFatal && values.wasOverdoseFatal !== 'yes' && (
            <Col sm>
              <Field
                name="acceptedTreatment"
                label="Further treatment accepted?"
                type="radio-group"
                options={acceptedTreatmentAnswers}
                required
                inline
              />
            </Col>
          )}
        </Row>

        <Field
          name="wasTransportedToHospital"
          label="Was client transported to a hospital?"
          type="radio-group"
          options={yesNoUnknown}
          inline
        />
      </CardBody>
    </>
  );
};

export default DrugOverdoseForm;
